<script>
  import { marked } from 'marked';
  import DOMPurify from 'dompurify';
  import ArtworkImage from './overlay-drawer-artwork-image.vue';

  export default {
    components: { ArtworkImage },
    props: {
        artwork: {
            type: Object,
            required: true,
        },
    },
    computed: {
        artist() {
            let artist = marked(this.artwork.ArtistNames);
            return DOMPurify.sanitize(artist);
        },
        title() {
            let title = marked(this.artwork.Title);
            return DOMPurify.sanitize(title);
        },
        displayDate() {
            let displayDate = marked(this.artwork.DisplayDate);
            return DOMPurify.sanitize(displayDate);
        },
        link() {
            return `/collection/works/${this.artwork.Id}`;
        }
    }
};
</script>

<template>
  <li
  class="
      @600/layout/width:max
      @600/layout/width:min
      layout/flex:column
      layout/overflow:hidden
      layout/width:max
      layout/width:min
    "
    style="
      --600--layout--width--max: 20rem;
      --600--layout--width--min: 20rem;
      --layout--width--max: 14.4rem;
      --layout--width--min: 14.4rem;
    "
    >
    <div
      class="
        @600/layout/height:max
        layout/height:max
      "
      style="
        --600--layout--height--max: 20rem;
        --layout--height--max: 14.4rem;
      "
      >
      <ArtworkImage
        :image-url="artwork.ImageURL"
        :alt-text="artwork.AltText"
      />
    </div>
    <div
      class="
        $typography/size:medium
        layout/margin:top:baseline
      "
      >
      <a
        class="
          layout/flex:column
          link/enable:children
          link/focus
        "
        :href="link"
      >
        <h3
          class="
            layout/margin:left:clear
            layout/margin:right:clear
            typography
          "
          v-html="artist"
        />
        <p
          class="
            $typography/scale:down
            $typography/weight:regular
            layout/margin:left:clear
            layout/margin:right:clear
            typography
            typography/truncate:2
          "
          v-html="title"
        />
        <p
          class="
            $typography/scale:down
            $typography/weight:regular
            layout/margin:left:clear
            layout/margin:right:clear
            typography
          "
          v-html="displayDate"
        />
      </a>
    </div>
  </li>
</template>